import firebase from './firebase'
import axios from 'axios'
import slugify from 'slugify'
import * as qs from 'query-string'

const getCurrentUser = () => {
    return firebase.auth().currentUser
}

let API_URL = `https://api.giv.link/api`
if (process.env.NODE_ENV === 'development') {
    API_URL = `http://localhost:3000/api`
}
const _apiClient = async (path, opts = {}) => {
    let token = await firebase.auth().currentUser?.getIdToken()
    if (!token) {
        token = localStorage.getItem('idToken')
        if (!token) {
            //hack if not token retry after firebase loads up
            await sleep(3000)
            token = await firebase.auth().currentUser?.getIdToken()
        }
    }
    const payload = { url: `${API_URL}${path}`, crossOrigin: true, ...opts }
    if (!payload.headers) payload.headers = {}
    payload.headers.authorization = `Bearer ${token}`
    const { data } = await axios(payload)
    // console.log(`${path}`, data)
    return data
}

export const sleep = ms => new Promise(res => setTimeout(res, ms))

export const deleteUser = (id, password) =>
    _apiClient(`/admin/users/${id}`, { method: 'DELETE', data: { password } })

export const searchUsersByName = name => _apiClient(`/admin/users?name=${name}`)

export const getUserProfile = uid => _apiClient(`/admin/users/${uid}`)

export const getPosts = async (limit = 30, offset = null) => {
    let qStr = `?limit=${limit}`
    if (offset) {
        qStr += `&offset=${offset}`
    }
    const items = await _apiClient(`/admin/posts${qStr}`)

    let off = null
    if (items.length) {
        off = items[items.length - 1].createdAt
    }
    return [items, off]
}

export const getInvite = code => _apiClient(`/admin/invites/${code}`)
export const getInvites = async (limit = 30, offset = null) => {
    let qStr = `?limit=${limit}`
    if (offset) {
        qStr += `&offset=${offset}`
    }
    const items = await _apiClient(`/admin/invites${qStr}`)

    let off = null
    if (items.length) {
        off = items[items.length - 1].createdAt
    }

    return [items, off]
}
export const getComments = async (limit = 30, offset = null) => {
    let qStr = `?limit=${limit}`
    if (offset) {
        qStr += `&offset=${offset}`
    }

    const items = await _apiClient(`/admin/comments${qStr}`)
    let off = null
    if (items.length) {
        off = items[items.length - 1].createdAt
    }

    return [items, off]
}

// limit = 30, offset = null
export const getChatGroups = async (filterMember = null) => {
    let url = `/admin/chat-groups`
    if (filterMember) {
        url += `?filterMember=${filterMember.id}`
    }
    const items = (await _apiClient(url)) || []
    let offset = null
    if (items && items.length) {
        offset = items[items.length - 1].createdAt
    }
    return [items, offset]
}

const DEFAULT_GET_USERS_OPTS = {
    limit: 30,
    offset: null,
}

export const getTotalLoginUsersCount = async (loginStartDate, loginEndDate, recencyFilter) => {
    const url = qs.stringifyUrl({
        url: `/admin/inactive-users-count`,
        query: { loginStartDate, loginEndDate, recencyFilter },
    })
    const stats = await _apiClient(url)
    return stats.count
}

export const getUsers = async (config, offsetKey = 'createdAt') => {
    const query = { ...DEFAULT_GET_USERS_OPTS, ...config }
    const url = qs.stringifyUrl({ url: `/admin/users`, query })

    console.log(url)
    const items = await _apiClient(url)

    let off = null
    if (items.length) {
        off = items[items.length - 1][offsetKey]
    }

    return [items, off]
}
export const toggleAdmin = (userId, value = false, password) => {
    return _apiClient(`/admin/users/${userId}/actions`, {
        method: 'PUT',
        data: { value, action: 'toggleAdmin', password },
    })
}
export const migrateUserToEmail = (userId, email) => {
    return _apiClient(`/admin/users/${userId}/actions`, {
        method: 'PUT',
        data: { action: 'migrateAccountToEmail', email },
    })
}

export const getPlaceCategories = () => _apiClient(`/admin/area-categories`)
export const getSkillCategories = () => _apiClient(`/admin/skill-categories`)
export const getGroups = () => _apiClient(`/admin/groups`)
export const getGivTypes = () => _apiClient(`/admin/giv-types`)
export const getSkills = () => _apiClient(`/admin/skills`)
export const getAreas = () => _apiClient(`/admin/areas`)
export const getNotes = id => _apiClient(`/admin/notes?userId=${id}`)
export const deleteNotes = ids => _apiClient(`/admin/notes`, { method: 'DELETE', data: { ids } })
export const addNote = (userId, note) =>
    _apiClient(`/admin/notes`, { method: 'POST', data: { userId, note } })

export const getGivRequests = async (
    type,
    limit = 30,
    offset = null,
    status = null,
    filterMember = null,
    sort = 'createdAt',
) => {
    let qStr = `?type=${type}&limit=${limit}`
    if (offset) {
        qStr += `&offset=${offset}`
    }
    if (filterMember) {
        qStr += `&filterMember=${filterMember}`
    }
    if (status) {
        qStr += `&status=${status}`
    }
    if (sort) {
        qStr += `&sort=${sort}`
    }

    const items = await _apiClient(`/admin/requests${qStr}`)

    let off = null
    if (items.length) {
        off = items[items.length - 1].createdAt
    }

    return [items, off]
}

export const getGivs = async (limit = 30, offset = null, filterMember = null) => {
    let qStr = `?limit=${limit}`
    if (offset) {
        qStr += `&offset=${offset}`
    }
    if (filterMember) {
        qStr += `&filterMember=${filterMember.id}`
    }

    const items = await _apiClient(`/admin/givs${qStr}`)

    let off = null
    if (items.length) {
        off = items[items.length - 1].createdAt
    }

    return [items, off]
}

export const getComment = id => _apiClient(`/admin/comments/${id}`)
export const getUserGivenGivs = uid => _apiClient(`/admin/givs?giverId=${uid}`)
export const getUserReceivedGivs = uid => _apiClient(`/admin/givs?receiverId=${uid}`)

export const getUser = async id => {
    const user = await _apiClient(`/admin/users/${id}`)
    user.givsGivenItems = await getUserGivenGivs(user.id)
    user.givsReceivedItems = await getUserReceivedGivs(user.id)
    return user
}
export const getRecentNotificationsForUser = async id => {
    const nots = await _apiClient(`/admin/users/${id}/notifications`)
    return nots
}
export const deleteNotificationForUser = async (userId, notId) => {
    return _apiClient(`/admin/users/${userId}/notifications/${notId}`, { method: 'DELETE' })
}
export const changeNotificationStatusForUser = async (userId, notId, status) => {
    return _apiClient(`/admin/users/${userId}/notifications/${notId}`, {
        method: 'PUT',
        data: { action: 'change-status', status },
    })
}
export const getSkill = id => _apiClient(`/admin/skills/${id}`)
export const getArea = id => _apiClient(`/admin/areas/${id}`)
export const getGivRequest = id => _apiClient(`/admin/requests/${id}`)
export const getGiv = id => _apiClient(`/admin/givs/${id}`)
export const getPost = id => _apiClient(`/admin/posts/${id}`)
export const deletePost = id => _apiClient(`/admin/posts/${id}`, { method: 'DELETE' })

export const createPlaceCategory = payload => {
    payload.id = slugify(payload.tagEn, { lower: true })
    if (!payload.order) payload.order = 0
    return _apiClient(`/admin/area-categories`, { method: 'POST', data: payload })
}
export const createSkillCategory = payload => {
    payload.id = slugify(payload.tagEn, { lower: true })
    if (!payload.order) payload.order = 0
    return _apiClient(`/admin/skill-categories`, { method: 'POST', data: payload })
}
export const createSkill = async payload => {
    payload.id = slugify(payload.tagEn, { lower: true })
    if (!payload.order) payload.order = 0
    return _apiClient(`/admin/skills`, { method: 'POST', data: payload })
}
export const createChatGroup = data => _apiClient(`/admin/chat-groups`, { method: 'POST', data })
export const updateChatGroup = (id, data) =>
    _apiClient(`/admin/chat-groups/${id}`, { method: 'PUT', data })
export const createArea = async payload => {
    payload.id = slugify(payload.tagEn, { lower: true })
    if (!payload.order) payload.order = 0
    return _apiClient(`/admin/areas`, { method: 'POST', data: payload })
}
export const createGiv = data => _apiClient(`/admin/givs`, { method: 'POST', data })

export const createInvite = async data => {
    const resp = await _apiClient(`/admin/invites`, { method: 'POST', data })
    return resp
}

export const updatePlaceCategory = (id, data) =>
    _apiClient(`/admin/area-categories/${id}`, { method: 'PUT', data })
export const updatePlaceCategoriesSorting = (placeCategories = []) => {
    const promises = []
    placeCategories.forEach((pc, idx) => {
        if (pc.order !== idx) {
            const p = _apiClient(`/admin/area-categories/${pc.id}`, {
                method: 'PUT',
                data: { order: idx },
            })
            promises.push(p)
        }
    })
    return Promise.all(promises)
}
export const updatePlacesSorting = (places = []) => {
    const promises = []
    places.forEach((p, idx) => {
        if (p.order !== idx) {
            const prom = _apiClient(`/admin/areas/${p.id}`, { method: 'PUT', data: { order: idx } })
            promises.push(prom)
        }
    })
    return Promise.all(promises)
}
export const updateSkillCategoriesSorting = (skillCategories = []) => {
    const promises = []
    skillCategories.forEach((sc, idx) => {
        if (sc.order !== idx) {
            const p = _apiClient(`/admin/skill-categories/${sc.id}`, {
                method: 'PUT',
                data: { order: idx },
            })
            promises.push(p)
        }
    })
    return Promise.all(promises)
}
export const updateSkillsSorting = (skills = []) => {
    const promises = []
    skills.forEach((s, idx) => {
        if (s.order !== idx) {
            const p = _apiClient(`/admin/skills/${s.id}`, { method: 'PUT', data: { order: idx } })
            promises.push(p)
        }
    })
    return Promise.all(promises)
}
export const updateSkillCategory = (id, data) =>
    _apiClient(`/admin/skill-categories/${id}`, { method: 'PUT', data })
export const updateSkill = (id, data) => _apiClient(`/admin/skills/${id}`, { method: 'PUT', data })

export const updateUser = (id, data) => _apiClient(`/admin/users/${id}`, { method: 'PUT', data })
export const updateArea = (id, data) => _apiClient(`/admin/areas/${id}`, { method: 'PUT', data })
export const updateGiv = (id, data) => _apiClient(`/admin/givs/${id}`, { method: 'PUT', data })
export const deleteChatGroup = id => _apiClient(`/admin/chat-groups/${id}`, { method: 'DELETE' })
export const deleteSkill = id => _apiClient(`/admin/skills/${id}`, { method: 'DELETE' })
export const deletePlaceCategory = id =>
    _apiClient(`/admin/area-categories/${id}`, { method: 'DELETE' })
export const deleteSkillCategory = id =>
    _apiClient(`/admin/skill-categories/${id}`, { method: 'DELETE' })
export const deleteSkillCategories = async ids => {
    if (!ids) return

    for (let id of ids) {
        await deleteSkillCategory(id)
    }
}
export const deleteArea = id => _apiClient(`/admin/areas/${id}`, { method: 'DELETE' })
export const deleteGiv = id => _apiClient(`/admin/givs/${id}`, { method: 'DELETE' })
export const updateGivRequest = (id, data) =>
    _apiClient(`/admin/requests/${id}`, { method: 'PUT', data })
export const deleteGivRequest = id => _apiClient(`/admin/requests/${id}`, { method: 'DELETE' })

export const getKpisV2 = async () => _apiClient(`/admin/kpis`)
export const getKpis = async (dateStr = 'current') => _apiClient(`/admin/kpis/${dateStr}`)

const formatYearMonth = d => {
    return d
        .toISOString()
        .split('T')[0]
        .slice(0, -3)
}
const ALL_METRICS = [
    {
        order: 9,
        key: 'skills',
        label: 'Skills Added',
        data: [],
    },
    {
        order: 8,
        key: 'areas',
        label: 'Areas Added',
        data: [],
    },
    {
        order: 7,
        key: 'postLiked',
        label: 'Likes',
        data: [],
        startingValue: 705,
    },
    {
        order: 6,
        key: 'comments',
        label: 'Comments Created',
        data: [],
        startingValue: 397,
    },
    {
        order: 5,
        key: 'givReceiveRequests',
        label: 'Received Requested',
        data: [],
        startingValue: 51,
    },
    {
        order: 4,
        key: 'givSendRequests',
        label: 'Send Requested',
        data: [],
        startingValue: 27,
    },
    {
        order: 3,
        key: 'givs',
        label: 'Givs Created',
        data: [],
        startingValue: 416,
    },
    {
        order: 2,
        key: 'posts',
        label: 'Posts Created',
        data: [],
        startingValue: 248,
    },
    {
        order: 1,
        key: 'users',
        label: 'New Users',
        data: [],
        startingValue: 138,
    },
]

export const getPastKpis = async (period = 6) => {
    const items = []
    let currTime = new Date()
    items.push(formatYearMonth(currTime))

    for (let i = 0; i < period - 1; i++) {
        currTime.setDate(1)
        currTime.setMonth(currTime.getMonth() - 1)
        items.push(formatYearMonth(currTime))
    }

    const promises = []
    for (let ds of items) {
        promises.push(getKpis(ds))
    }

    const kpis = await Promise.all(promises)
    kpis.sort((a, b) => {
        return a.id < b.id ? -1 : 1
    })
    items.sort((a, b) => {
        return a < b ? -1 : 1
    })

    const allMetrics = ALL_METRICS.map(m => ({ ...m, months: items }))
    kpis.forEach((kpi, idxOuter) => {
        allMetrics.forEach((m, idx) => {
            const val = kpi[m.key] || 0
            allMetrics[idx].data[idxOuter] = val
        })
    })

    return allMetrics
}

export default {
    getCurrentUser,
    getAreas,
    getSkills,
    getGroups,
    getSkillCategories,
    getPlaceCategories,
    getGivs,
    getUsers,
    getChatGroups,
    getComments,
    createChatGroup,
    updateChatGroup,
    getInvites,
    getInvite,
    getPosts,
    createGiv,
    createArea,
    createSkill,
    createSkillCategory,
    createPlaceCategory,
    createInvite,
    updateUser,
    updateGiv,
    updateArea,
    updateSkill,
    updatePlacesSorting,
    updatePlaceCategoriesSorting,
    updateSkillsSorting,
    updateSkillCategory,
    updateSkillCategoriesSorting,
    updatePlaceCategory,
    deleteSkill,
    deleteSkillCategory,
    deletePlaceCategory,
    deleteSkillCategories,
    deleteGiv,
    deleteChatGroup,
    deleteGivRequest,
    updateGivRequest,
    deleteArea,
    getKpis,
    getKpisV2,
    getPastKpis,
    getUserProfile,
    searchUsersByName,
    getGiv,
    getGivRequest,
    getGivRequests,
    getArea,
    getSkill,
    getNotes,
    addNote,
    deleteNotes,
    getUser,
    getComment,
    getPost,
    deleteUser,
    sleep,
    deletePost,
    getTotalLoginUsersCount,
    getRecentNotificationsForUser,
    deleteNotificationForUser,
    changeNotificationStatusForUser,
    getGivTypes,
    toggleAdmin,
    migrateUserToEmail,
}
